import React from 'react';
import Icon from '../components/Icon';
import { t } from '../lib/i18n';

/**
 * DeltaArrow -- Shows score change with up/down arrow and color.
 *
 * Props:
 *   value: number | null | undefined  -- score delta
 *
 * Renders nothing when value is null/undefined.
 */
export default function DeltaArrow({ value }) {
    if (value === null || value === undefined) return null;

    const positive = value >= 0;

    return (
        <span className={`flex items-center gap-0.5 text-xs font-medium ${positive ? 'text-emerald-500' : 'text-red-500'}`}>
            <Icon name={positive ? 'trending-up' : 'trending-down'} className="w-3.5 h-3.5" />
            {`${positive ? '+' : ''}${value} ${t('reports_vs_previous')}`}
        </span>
    );
}
